import styled from "styled-components";

export const PageContainer = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #E5F8FA;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SendChangeRequestButton = styled.button`
        border: none;
        background-color: #FDCAC3;
        padding: 15px;
        width: 200px;
        border-radius: 30px;
        align-self: flex-end;
        margin-top: 50px;
        cursor: pointer;

        &:hover{
            background-color: #e0e0e0;
        }
`

export const DependentsList = styled.div`
  width: 100%;
  max-width: 80%;
  overflow-y: auto;
  margin-top: 10px;
  max-height: 40vh;
  padding: 40px;

`;

export const StyledButton = styled.button`
  background-color: #007bff;
  color: white;
  font-weight: bold;
  padding: 0.8rem 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 1rem;

  &:hover {
    background-color: #0056b3;
  }
`;

export const AddDependentsButton = styled.button`
  width: 180px;
  padding: 15px;
  margin-right: -90px;
  background-color: #D0E1EF;
  color: #005CA9;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  border: none;
  border-radius: 60px;
  cursor: pointer;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
`
